import { Tabs } from 'antd';
import React, { useState } from 'react';
import Detail from './Detail';
import ScheduleAndCharge from './ScheduleAndCharge/index';
import AccessibilityAndSecurity from './AccessibilityAndSecurity/index';

const { TabPane } = Tabs;
interface propsTypes {
  isEditable?: void | any;
  cancelEditable?: void | any;
  disableTabPanes?: void | any;
  detail?: any;
  cancelAndSave?: void | any;
  tableCurrentData?: any;
}
const DetailPageTab = (props: propsTypes) => {
  const editFlag = false;
  const [disabledFlag, setDisabledFlag] = useState<any>(false);

  return (
    <>
      <Tabs defaultActiveKey="1">
        <TabPane
          tab="Detail"
          key="1"
          disabled={disabledFlag}
        >
          <Detail
            setDisabledFlag={setDisabledFlag}
            disableTabPanes={props.disableTabPanes}
            tableCurrentData={props.tableCurrentData}
            isEditable={props.isEditable}
            cancelEditable={props.cancelEditable}
            cancelAndSave={props.cancelAndSave}
            editFlag={editFlag}
          />
        </TabPane>
        <TabPane
          tab="Schedule & Charges"
          key="2"
          disabled={disabledFlag}
        >
          <ScheduleAndCharge
            setDisabledFlag={setDisabledFlag}
            scheduleAndChargeData={props.tableCurrentData}
            isEditable={props.isEditable}
            cancelEditable={props.cancelEditable}
            cancelAndSave={props.cancelAndSave}
          />
        </TabPane>
        <TabPane
          tab="Accessibility/Security"
          key="3"
          disabled={disabledFlag}
        >
          <AccessibilityAndSecurity
            setDisabledFlag={setDisabledFlag}
            isEditable={props.isEditable}
            cancelEditable={props.cancelEditable}
            cancelAndSave={props.cancelAndSave}
            scheduleAndChargeData={props.tableCurrentData}
          />
        </TabPane>
      </Tabs>
    </>
  );
};
export default DetailPageTab;
